import CheckIcon from "./CheckIcon.js";


export function GreenCheckIcon() {
    return (
        <CheckIcon className="inline size-[2em] fill-success pb-[0.5em] align-middle" />
    );
}
